import { PageView, PageTopBar, Button } from "../../../components"
import { MESSAGES } from "../constants/messages"

export const WarehouseValidation = ({ onNavigateToWarehouses }) => {
  return (
    <PageView
      topMenu={
        <PageTopBar>
          <div className="text-lg font-semibold text-red-600">
            {MESSAGES.WAREHOUSE_NOT_ALLOWED.title}
          </div>
        </PageTopBar>
      }
    >
      <div className="text-center py-8">
        <div className="text-red-600 text-xl mb-4">
          ⚠️ {MESSAGES.WAREHOUSE_NOT_ALLOWED.description}
        </div>
        <p className="text-gray-600 mb-4">
          Este armazém não está na lista de armazéns permitidos.
        </p>
        <Button 
          onClick={onNavigateToWarehouses}
          className="mt-4"
        >
          {MESSAGES.BUTTONS.goToWarehouses}
        </Button>
      </div>
    </PageView>
  )
} 